export const staticUrlPath = process.env.PUBLIC_URL || '';
